export default __webpack_public_path__ + "static/B0203-5fe43ccea2ab72c969a4b589b49e03cf.png";